import * as React from 'react';
import '../../../panels/panels.css';
import {
    Button,
    Label,
    Segment,
    Form,
    Checkbox,
    Dropdown,
    Input,
    Radio,
    Modal,
    Header,
    Icon
} from 'semantic-ui-react';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import Toast from '../../../sys/toast';
import OAuth, { OAuthClientStatus } from '../../../api';

class State {
    hlsVodCont: boolean;
    hlsStreamIdReq: boolean;
    hlsRedirectPlaylist: boolean;
    hlsRedirectMediaPlaylist: boolean;
    hlsRedirectMedia: boolean;
    hlsRedirectKey: boolean;
    hlsShareConn: boolean;
    hlsPersistConn: boolean;
    hlsDecrypt: boolean;
    hlsDvstMasterTime: boolean;
    hlsCookieMode: boolean;
    hlsPlaylistGzip: boolean;
    hlsMediaPlaylistUrlUpdate: boolean;
    hlsMasterPlaylistRefresh: any;
    hlsVarNameOptBandwidth: boolean;
    hlsVarNameOptResolution: boolean;
    hlsVarNameOptAltRendGroupId: boolean;
    hlsVarNameOptAltRendType: boolean;
    hlsVarNameOptAltRendName: boolean;
    hlsVarNameOptAltRendLang: boolean;
    hlsVarNameOptMediaPlaylistName: boolean;
    hlsVarNameOptEncVarName: boolean;
    hlsAutoStartComp: string;
    hlsAutoStartCompAllMedia: boolean;
    hlsAutoStartCompAllAltRendAudio: boolean;
    hlsAutoStartCompAllAltRendSubtitle: boolean;
    hlsAutoStartCompLimitMedia: boolean;
    hlsAutoStartCompLimitAltRendAudio: boolean;
    hlsAutoStartCompLimitAltRendSubtitle: boolean;
    hlsAutoStartCompLimitMediaVar: string;
    hlsAutoStartCompLimitAltRendAudioVar: string;
    hlsAutoStartCompLimitAltRendSubtitleVar: string;
    hlsInitReqMode: any;
    hlsMediaFileStartPos: any;
    hlsVarNameOptPatternMatch: boolean;
    hlsAutoStartCompNoDup: boolean;
    hlsMediaFileDurationChkMode: any;
    hlsDaiEnable: boolean;
    hlsPersistConnTimeout: any;
    hlsIFrameVariantsEnable: boolean;
    hlsAutoStartCompAllIFrame: boolean;
    hlsAutoStartCompLimitIFrame: boolean;
    hlsAutoStartCompLimitIFrameVar: string;
    hlsVarNameOptIFrameType: boolean;
    hlsMediaPlaylistDeltaUpdateEnable: boolean;
    hlsMasterPlaylistVariantResync: boolean;
    timeoutHelpModalOpen: boolean;
    hlsQoeAllVideo: boolean;
    hlsQoeAllAudio: boolean;
    hlsQoeAllPixel: boolean;
    hlsQoeLimitVideo: boolean;
    hlsQoeLimitAudio: boolean;
    hlsQoeLimitPixel: boolean;
    hlsPlaylistChangeLiveToVodEnable: boolean;
    hlsPlaylistChangeVodToLiveEnable: boolean;
}

interface Props {

}

export default class AppleStreamingConfig extends React.Component<Props, State> {

    componentWillMount() {
        this.setState({
            hlsVodCont: false,
            hlsStreamIdReq: false,
            hlsRedirectPlaylist: false,
            hlsRedirectMediaPlaylist: false,
            hlsRedirectMedia: false,
            hlsRedirectKey: false,
            hlsShareConn: false,
            hlsPersistConn: false,
            hlsDecrypt: false,
            hlsDvstMasterTime: false,
            hlsCookieMode: false,
            hlsPlaylistGzip: false,
            hlsMediaPlaylistUrlUpdate: false,
            hlsMasterPlaylistRefresh: '',
            hlsVarNameOptBandwidth: false,
            hlsVarNameOptResolution: false,
            hlsVarNameOptAltRendGroupId: false,
            hlsVarNameOptAltRendType: false,
            hlsVarNameOptAltRendName: false,
            hlsVarNameOptAltRendLang: false,
            hlsVarNameOptMediaPlaylistName: false,
            hlsVarNameOptEncVarName: false,
            hlsAutoStartComp: '',
            hlsAutoStartCompAllMedia: false,
            hlsAutoStartCompAllAltRendAudio: false,
            hlsAutoStartCompAllAltRendSubtitle: false,
            hlsAutoStartCompLimitMedia: false,
            hlsAutoStartCompLimitAltRendAudio: false,
            hlsAutoStartCompLimitAltRendSubtitle: false,
            hlsAutoStartCompLimitMediaVar: '',
            hlsAutoStartCompLimitAltRendAudioVar: '',
            hlsAutoStartCompLimitAltRendSubtitleVar: '',
            hlsInitReqMode: '',
            hlsMediaFileStartPos: '',
            hlsVarNameOptPatternMatch: false,
            hlsAutoStartCompNoDup: false,
            hlsMediaFileDurationChkMode: '',
            hlsDaiEnable: false,
            hlsPersistConnTimeout: '',
            hlsIFrameVariantsEnable: false,
            hlsAutoStartCompAllIFrame: false,
            hlsAutoStartCompLimitIFrame: false,
            hlsAutoStartCompLimitIFrameVar: '',
            hlsVarNameOptIFrameType: false,
            hlsMediaPlaylistDeltaUpdateEnable: false,
            hlsMasterPlaylistVariantResync: false,
            timeoutHelpModalOpen: false,
            hlsQoeAllVideo: false,
            hlsQoeAllAudio: false,
            hlsQoeAllPixel: false,
            hlsQoeLimitVideo: false,
            hlsQoeLimitAudio: false,
            hlsQoeLimitPixel: false,
            hlsPlaylistChangeLiveToVodEnable: false,
            hlsPlaylistChangeVodToLiveEnable: false
        });

        this.fetchData();
        this.setTimeoutHelpModalOpen = this.setTimeoutHelpModalOpen.bind(this);
    }

    fetchData() {
        let _this = this;
        let url = 'http://default/api/config/section/options/abr';
        axios.post(url, {
            mode: 'get',
            defaults: {},
            options: [
                'hlsVodCont', 'hlsStreamIdReq', 'hlsRedirectPlaylist', 'hlsRedirectMediaPlaylist', 'hlsRedirectMedia', 'hlsRedirectKey', 'hlsShareConn',
                'hlsPersistConn', 'hlsDecrypt', 'hlsDvstMasterTime', 'hlsCookieMode', 'hlsPlaylistGzip', 'hlsMediaPlaylistUrlUpdate',
                'hlsMasterPlaylistRefresh', 'hlsVarNameOptBandwidth', 'hlsVarNameOptResolution', 'hlsVarNameOptAltRendGroupId',
                'hlsVarNameOptAltRendType', 'hlsVarNameOptAltRendName', 'hlsVarNameOptAltRendLang', 'hlsVarNameOptMediaPlaylistName',
                'hlsVarNameOptEncVarName', 'hlsAutoStartComp', 'hlsAutoStartCompAllMedia', 'hlsAutoStartCompAllAltRendAudio',
                'hlsAutoStartCompAllAltRendSubtitle', 'hlsAutoStartCompLimitMedia', 'hlsAutoStartCompLimitAltRendAudio',
                'hlsAutoStartCompLimitAltRendSubtitle', 'hlsAutoStartCompLimitMediaVar', 'hlsAutoStartCompLimitAltRendAudioVar',
                'hlsAutoStartCompLimitAltRendSubtitleVar', 'hlsInitReqMode', 'hlsMediaFileStartPos', 'hlsVarNameOptPatternMatch',
                'hlsAutoStartCompNoDup', 'hlsMediaFileDurationChkMode', 'hlsDaiEnable', 'hlsPersistConnTimeout', 'hlsIFrameVariantsEnable',
                'hlsAutoStartCompAllIFrame', 'hlsAutoStartCompLimitIFrame', 'hlsAutoStartCompLimitIFrameVar', 'hlsVarNameOptIFrameType',
                'hlsMediaPlaylistDeltaUpdateEnable', 'hlsMasterPlaylistVariantResync',
                'hlsQoeAllVideo', 'hlsQoeAllAudio', 'hlsQoeAllPixel', 'hlsQoeLimitVideo', 'hlsQoeLimitAudio', 'hlsQoeLimitPixel',
                'hlsPlaylistChangeLiveToVodEnable', 'hlsPlaylistChangeVodToLiveEnable'
            ]
        })
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.section !== undefined) {
                    let responseObject = response.data.section.options;

                    _this.setState({
                        hlsVodCont: responseObject[0].value,
                        hlsStreamIdReq: responseObject[1].value,
                        hlsRedirectPlaylist: responseObject[2].value,
                        hlsRedirectMediaPlaylist: responseObject[3].value,
                        hlsRedirectMedia: responseObject[4].value,
                        hlsRedirectKey: responseObject[5].value,
                        hlsShareConn: responseObject[6].value,
                        hlsPersistConn: responseObject[7].value,
                        hlsDecrypt: responseObject[8].value,
                        hlsDvstMasterTime: responseObject[9].value,
                        hlsCookieMode: responseObject[10].value,
                        hlsPlaylistGzip: responseObject[11].value,
                        hlsMediaPlaylistUrlUpdate: responseObject[12].value,
                        hlsMasterPlaylistRefresh: responseObject[13].value,
                        hlsVarNameOptBandwidth: responseObject[14].value,
                        hlsVarNameOptResolution: responseObject[15].value,
                        hlsVarNameOptAltRendGroupId: responseObject[16].value,
                        hlsVarNameOptAltRendType: responseObject[17].value,
                        hlsVarNameOptAltRendName: responseObject[18].value,
                        hlsVarNameOptAltRendLang: responseObject[19].value,
                        hlsVarNameOptMediaPlaylistName: responseObject[20].value,
                        hlsVarNameOptEncVarName: responseObject[21].value,
                        hlsAutoStartComp: responseObject[22].value,
                        hlsAutoStartCompAllMedia: responseObject[23].value,
                        hlsAutoStartCompAllAltRendAudio: responseObject[24].value,
                        hlsAutoStartCompAllAltRendSubtitle: responseObject[25].value,
                        hlsAutoStartCompLimitMedia: responseObject[26].value,
                        hlsAutoStartCompLimitAltRendAudio: responseObject[27].value,
                        hlsAutoStartCompLimitAltRendSubtitle: responseObject[28].value,
                        hlsAutoStartCompLimitMediaVar: responseObject[29].value,
                        hlsAutoStartCompLimitAltRendAudioVar: responseObject[30].value,
                        hlsAutoStartCompLimitAltRendSubtitleVar: responseObject[31].value,
                        hlsInitReqMode: responseObject[32].value,
                        hlsMediaFileStartPos: responseObject[33].value,
                        hlsVarNameOptPatternMatch: responseObject[34].value,
                        hlsAutoStartCompNoDup: responseObject[35].value,
                        hlsMediaFileDurationChkMode: responseObject[36].value,
                        hlsDaiEnable: responseObject[37].value,
                        hlsPersistConnTimeout: responseObject[38].value,
                        hlsIFrameVariantsEnable: responseObject[39].value,
                        hlsAutoStartCompAllIFrame: responseObject[40].value,
                        hlsAutoStartCompLimitIFrame: responseObject[41].value,
                        hlsAutoStartCompLimitIFrameVar: responseObject[42].value,
                        hlsVarNameOptIFrameType: responseObject[43].value,
                        hlsMediaPlaylistDeltaUpdateEnable: responseObject[44].value,
                        hlsMasterPlaylistVariantResync: responseObject[45].value,
                        hlsQoeAllVideo: responseObject[46].value,
                        hlsQoeAllAudio: responseObject[47].value,
                        hlsQoeAllPixel: responseObject[48].value,
                        hlsQoeLimitVideo: responseObject[49].value,
                        hlsQoeLimitAudio: responseObject[50].value,
                        hlsQoeLimitPixel: responseObject[51].value,
                        hlsPlaylistChangeLiveToVodEnable: responseObject[52].value,
                        hlsPlaylistChangeVodToLiveEnable: responseObject[53].value
                    });
                } else
                    // tslint:disable-next-line:no-console
                    console.log('expected array of config values, got ', response.data);
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('fetchData() error: ', error);
            });

    }

    updateConfig(e: any, data: any) {
        //    let _this = this;
        let url = 'http://default/api/config/section/options/abr';

        axios.post(url, {
            mode: 'modify',
            defaults: {},
            options: [
                {'name': 'hlsVodCont', 'value': this.state.hlsVodCont},
                {'name': 'hlsStreamIdReq', 'value': this.state.hlsStreamIdReq},
                {'name': 'hlsRedirectPlaylist', 'value': this.state.hlsRedirectPlaylist},
                {'name': 'hlsRedirectMediaPlaylist', 'value': this.state.hlsRedirectMediaPlaylist},
                {'name': 'hlsRedirectMedia', 'value': this.state.hlsRedirectMedia},
                {'name': 'hlsRedirectKey', 'value': this.state.hlsRedirectKey},
                {'name': 'hlsShareConn', 'value': this.state.hlsShareConn},
                {'name': 'hlsPersistConn', 'value': this.state.hlsPersistConn},
                {'name': 'hlsDecrypt', 'value': this.state.hlsDecrypt},
                {'name': 'hlsDvstMasterTime', 'value': this.state.hlsDvstMasterTime},
                {'name': 'hlsCookieMode', 'value': this.state.hlsCookieMode},
                {'name': 'hlsPlaylistGzip', 'value': this.state.hlsPlaylistGzip},
                {'name': 'hlsMediaPlaylistUrlUpdate', 'value': this.state.hlsMediaPlaylistUrlUpdate},
                {'name': 'hlsMasterPlaylistRefresh', 'value': this.state.hlsMasterPlaylistRefresh},
                {'name': 'hlsVarNameOptBandwidth', 'value': this.state.hlsVarNameOptBandwidth},
                {'name': 'hlsVarNameOptResolution', 'value': this.state.hlsVarNameOptResolution},
                {'name': 'hlsVarNameOptAltRendGroupId', 'value': this.state.hlsVarNameOptAltRendGroupId},
                {'name': 'hlsVarNameOptAltRendType', 'value': this.state.hlsVarNameOptAltRendType},
                {'name': 'hlsVarNameOptAltRendName', 'value': this.state.hlsVarNameOptAltRendName},
                {'name': 'hlsVarNameOptAltRendLang', 'value': this.state.hlsVarNameOptAltRendLang},
                {'name': 'hlsVarNameOptMediaPlaylistName', 'value': this.state.hlsVarNameOptMediaPlaylistName},
                {'name': 'hlsVarNameOptEncVarName', 'value': this.state.hlsVarNameOptEncVarName},
                {'name': 'hlsAutoStartComp', 'value': this.state.hlsAutoStartComp},
                {'name': 'hlsAutoStartCompAllMedia', 'value': this.state.hlsAutoStartCompAllMedia},
                {'name': 'hlsAutoStartCompAllAltRendAudio', 'value': this.state.hlsAutoStartCompAllAltRendAudio},
                {'name': 'hlsAutoStartCompAllAltRendSubtitle', 'value': this.state.hlsAutoStartCompAllAltRendSubtitle},
                {'name': 'hlsAutoStartCompLimitMedia', 'value': this.state.hlsAutoStartCompLimitMedia},
                {'name': 'hlsAutoStartCompLimitAltRendAudio', 'value': this.state.hlsAutoStartCompLimitAltRendAudio},
                {
                    'name': 'hlsAutoStartCompLimitAltRendSubtitle',
                    'value': this.state.hlsAutoStartCompLimitAltRendSubtitle
                },
                {'name': 'hlsAutoStartCompLimitMediaVar', 'value': this.state.hlsAutoStartCompLimitMediaVar},
                {
                    'name': 'hlsAutoStartCompLimitAltRendAudioVar',
                    'value': this.state.hlsAutoStartCompLimitAltRendAudioVar
                },
                {
                    'name': 'hlsAutoStartCompLimitAltRendSubtitleVar',
                    'value': this.state.hlsAutoStartCompLimitAltRendSubtitleVar
                },
                {'name': 'hlsInitReqMode', 'value': this.state.hlsInitReqMode},
                {'name': 'hlsMediaFileStartPos', 'value': this.state.hlsMediaFileStartPos},
                {'name': 'hlsVarNameOptPatternMatch', 'value': this.state.hlsVarNameOptPatternMatch},
                {'name': 'hlsAutoStartCompNoDup', 'value': this.state.hlsAutoStartCompNoDup},
                {'name': 'hlsMediaFileDurationChkMode', 'value': this.state.hlsMediaFileDurationChkMode},
                {'name': 'hlsDaiEnable', 'value': this.state.hlsDaiEnable},
                {'name': 'hlsPersistConnTimeout', 'value': this.state.hlsPersistConnTimeout},
                {'name': 'hlsIFrameVariantsEnable', 'value': this.state.hlsIFrameVariantsEnable},
                {'name': 'hlsAutoStartCompAllIFrame', 'value': this.state.hlsAutoStartCompAllIFrame},
                {'name': 'hlsAutoStartCompLimitIFrame', 'value': this.state.hlsAutoStartCompLimitIFrame},
                {'name': 'hlsAutoStartCompLimitIFrameVar', 'value': this.state.hlsAutoStartCompLimitIFrameVar},
                {'name': 'hlsVarNameOptIFrameType', 'value': this.state.hlsVarNameOptIFrameType},
                {'name': 'hlsMediaPlaylistDeltaUpdateEnable', 'value': this.state.hlsMediaPlaylistDeltaUpdateEnable},
                {'name': 'hlsMasterPlaylistVariantResync', 'value': this.state.hlsMasterPlaylistVariantResync},
                {'name': 'hlsQoeAllVideo', 'value': this.state.hlsQoeAllVideo},
                {'name': 'hlsQoeAllAudio', 'value': this.state.hlsQoeAllAudio},
                {'name': 'hlsQoeAllPixel', 'value': this.state.hlsQoeAllPixel},
                {'name': 'hlsQoeLimitVideo', 'value': this.state.hlsQoeLimitVideo},
                {'name': 'hlsQoeLimitAudio', 'value': this.state.hlsQoeLimitAudio},
                {'name': 'hlsQoeLimitPixel', 'value': this.state.hlsQoeLimitPixel},
                {'name': 'hlsPlaylistChangeLiveToVodEnable', 'value': this.state.hlsPlaylistChangeLiveToVodEnable},
                {'name': 'hlsPlaylistChangeVodToLiveEnable', 'value': this.state.hlsPlaylistChangeVodToLiveEnable}
            ]
        })
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.code === 'SUCCESS') {
                    Toast.info('Apple / HTTP Live Streaming configuration applied');
                } else {
                    Toast.error('Apple / HTTP Live Streaming configuration failed');
                }

            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('updateConfig() error: ', error);
                Toast.error('Apple / HTTP Live Streaming configuration failed');
            });
    }

    // Set the Timeout help Modal to open/closed
    setTimeoutHelpModalOpen(isOpen: boolean) {
        this.setState({timeoutHelpModalOpen: isOpen});
    }

    toggleVideo(index: any) {
        if (index === 1) {
            if (this.state.hlsQoeAllVideo) {
                this.setState({hlsQoeAllVideo: false, hlsQoeAllPixel: false});
            } else {
                this.setState({hlsQoeAllVideo: true});
            }
        } else {
            if (this.state.hlsQoeLimitVideo) {
                this.setState({hlsQoeLimitVideo: false, hlsQoeLimitPixel: false});
            } else {
                this.setState({hlsQoeLimitVideo: true});
            }
        }
    }

    render() {
        const masterPlaylistOptions = [
            {value: 'disabled', text: 'disabled'},
            {value: 60, text: '60 seconds'},
            {value: 300, text: '5 minutes'},
            {value: 900, text: '15 minutes'}
        ];
        const initFileReqModeOptions = [
            {value: 'never', text: 'Never'},
            {value: 'init', text: 'Init'},
            {value: '100', text: '100'},
            {value: '1000', text: '1000'}
        ];
        const mediaFileStartPosOptions = [
            {value: 'auto', text: 'Auto'},
            {value: 'begin', text: 'Begin'},
            {value: 'end', text: 'End'}
        ];
        const hlsMediaFileDurationChkModeOptions = [
            {value: 'ignore', text: 'Ignore'},
            {value: 'warn', text: 'Warn'},
            {value: 'fail', text: 'Fail'}
        ];

        const hlsStreamingOptions = [
            {stateName: 'hlsVodCont', label: 'Play VOD Streams Continuously'},
            {stateName: 'hlsStreamIdReq', label: 'Include Stream Identifier Cookie In HTTP Requests'},
            {stateName: 'hlsRedirectPlaylist', label: 'Enable Master Playlist Redirect'},
            {stateName: 'hlsRedirectMediaPlaylist', label: 'Enable Media Playlist Redirect'},
            {stateName: 'hlsRedirectMedia', label: 'Enable Media Redirect'},
            {stateName: 'hlsRedirectKey', label: 'Enable Key Redirect'},
            {stateName: 'hlsShareConn', label: 'Enable Shared Media Playlist/Media Connections'},
            {stateName: 'hlsPersistConn', label: 'Enable Persistent Connections'},
            {stateName: 'hlsDecrypt', label: 'Enable Decryption'},
            {
                stateName: 'hlsDvstMasterTime',
                label: 'Include Master Playlist Startup Time In Derived Variant Startup Time'
            },
            {stateName: 'hlsCookieMode', label: 'Enable Cookies'},
            {stateName: 'hlsPlaylistGzip', label: 'Enable Master/Media Playlist GZIP Compression'},
            {stateName: 'hlsMasterPlaylistVariantResync', label: 'Enable Variant Resync on Master Playlist change'},
            {stateName: 'hlsMediaPlaylistUrlUpdate', label: 'Enable Media Playlist URL Update'},
            {stateName: 'hlsMediaPlaylistDeltaUpdateEnable', label: 'Enable Media Playlist Delta Update'},
            {stateName: 'hlsIFrameVariantsEnable', label: 'Enable I-Frame Variants'},
            {stateName: 'hlsPlaylistChangeLiveToVodEnable', label: 'Enable playlist change from live to VOD'},
            {stateName: 'hlsPlaylistChangeVodToLiveEnable', label: 'Enable playlist change from VOD to live'}
        ];

        const hlsVariantNameOptions = [
            {stateName: 'hlsVarNameOptBandwidth', label: 'Bandwidth'},
            {stateName: 'hlsVarNameOptResolution', label: 'Resolution'},
            {stateName: 'hlsVarNameOptAltRendGroupId', label: 'Group Identifier (Alternate Rendition)'},
            {stateName: 'hlsVarNameOptAltRendType', label: 'Type (Alternate Rendition)'},
            {stateName: 'hlsVarNameOptAltRendName', label: 'Name (Alternate Rendition)'},
            {stateName: 'hlsVarNameOptAltRendLang', label: 'Language (Alternate Rendition)'},
            {stateName: 'hlsVarNameOptIFrameType', label: 'Type (I-Frame)'},
            {stateName: 'hlsVarNameOptMediaPlaylistName', label: 'Media Playlist File Name'},
            {stateName: 'hlsVarNameOptEncVarName', label: 'Encoder Variant Name'}
        ];

        return (
            <OAuth.Context>
                {(oauth: OAuthClientStatus) => {
                    return (
                        <React.Fragment>
                            <div className="assetAliasFilters">
                                <Label className="system-config-pageHeader">
                                    Apple/HTTP Live Streaming
                                </Label>
                                <Button
                                    floated="right"
                                    className="rightButton"
                                    content="Apply"
                                    title="Update Config"
                                    onClick={(e, data) => this.updateConfig(e, data)}
                                />
                            </div>
                            <div className="vertical-flex-main">
                                <Segment.Group className="system-config-segment">
                                    <Segment className="segment-header">Streaming Options</Segment>
                                    <Segment>
                                        <Form>
                                            {!oauth.VODOnlyLicensePresent ?
                                                hlsStreamingOptions.map((streamingOption, index) => {
                                                    return <Form.Group grouped key={streamingOption.stateName}>
                                                        <Checkbox
                                                            className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                            checked={this.state[streamingOption.stateName]}
                                                            onChange={(e: any, data: any) => this.setState({
                                                                ...this.state,
                                                                [streamingOption.stateName]: data.checked
                                                            })}
                                                        />
                                                        <Label
                                                            className={(streamingOption.stateName === 'hlsPersistConn' || 'hlsMasterPlaylistVariantResync') ? 'left-align-label-min150' : 'left-align-label-500'}
                                                        >
                                                            {streamingOption.label}
                                                        </Label>
                                                        {streamingOption.stateName === 'hlsPersistConn' &&
                                                        <>
                                                            <Label
                                                                className={!this.state.hlsPersistConn ? 'right-align-label-width170 label-disabled' : 'right-align-label-width170'}
                                                            >
                                                                Timeout (seconds)
                                                            </Label>
                                                            <Input
                                                                className="small-input"
                                                                disabled={!this.state.hlsPersistConn}
                                                                type="number"
                                                                min="0"
                                                                max="600"
                                                                value={this.state.hlsPersistConnTimeout}
                                                                onChange={(e: any, data: any) => this.setState({hlsPersistConnTimeout: data.value})}
                                                            />
                                                        </>
                                                        }
                                                        {streamingOption.stateName === 'hlsMasterPlaylistVariantResync' &&
                                                        <Modal
                                                            closeIcon
                                                            onClose={() => this.setTimeoutHelpModalOpen(false)}
                                                            onOpen={() => this.setTimeoutHelpModalOpen(true)}
                                                            open={this.state.timeoutHelpModalOpen}
                                                            size="small"
                                                            trigger={<Icon
                                                                name="question circle"
                                                                size="small"
                                                                style={{paddingLeft: '10px'}}
                                                            />}
                                                        >
                                                            <Header as="h5" icon className="speedModalHeader">
                                                                Enable Variant Resync
                                                            </Header>
                                                            <Modal.Content>
                                                                <p>
                                                                    {/* tslint:disable-next-line:max-line-length */}
                                                                    When enabled, changes to the number of variants or
                                                                    the
                                                                    key
                                                                    attributes associated with variants in the Master
                                                                    Playlist will
                                                                    result in the existing variant streams being stopped
                                                                    and
                                                                    new
                                                                    streams created based on the Master Playlist
                                                                    updates.
                                                                    For a list
                                                                    of key attributes based on variant type, reference
                                                                    the
                                                                    Surveyor
                                                                    ABR Active User Guide for more details.
                                                                </p>
                                                                <p>
                                                                    <b>Note:</b> Changes to a variant URL is not a key
                                                                    attribute.
                                                                    URL updates can be enabled to resync variant URL
                                                                    with a
                                                                    separate
                                                                    configuration parameter - Enable Media Playlist URL
                                                                    Update.
                                                                </p>
                                                            </Modal.Content>
                                                        </Modal>
                                                        }
                                                    </Form.Group>;
                                                })
                                                : null}
                                            <Form.Group grouped>
                                                <Label className="left-align-label-min200" style={{paddingLeft: '10%'}}>
                                                    Master Playlist Refresh
                                                </Label>
                                                <Dropdown
                                                    search
                                                    value={this.state.hlsMasterPlaylistRefresh}
                                                    options={masterPlaylistOptions}
                                                    selection
                                                    onChange={(event, data) => this.setState({hlsMasterPlaylistRefresh: data.value})}
                                                />
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="left-align-label-min200" style={{paddingLeft: '10%'}}>
                                                    Initialization File Request Mode
                                                </Label>
                                                <Dropdown
                                                    search
                                                    value={this.state.hlsInitReqMode}
                                                    options={initFileReqModeOptions}
                                                    selection
                                                    onChange={(event, data) => this.setState({hlsInitReqMode: data.value})}
                                                />
                                            </Form.Group>
                                            {!oauth.VODOnlyLicensePresent ?
                                                <Form.Group grouped>
                                                    <Label
                                                        className="left-align-label-min200"
                                                        style={{paddingLeft: '10%'}}
                                                    >
                                                        Media File Start Position
                                                    </Label>
                                                    <Dropdown
                                                        search
                                                        value={this.state.hlsMediaFileStartPos}
                                                        options={mediaFileStartPosOptions}
                                                        selection
                                                        onChange={(event, data) => this.setState({hlsMediaFileStartPos: data.value})}
                                                    />
                                                </Form.Group>
                                                : null}
                                            <Form.Group grouped>
                                                <Label className="left-align-label-min200" style={{paddingLeft: '10%'}}>
                                                    Media File Duration Check Mode
                                                </Label>
                                                <Dropdown
                                                    search
                                                    value={this.state.hlsMediaFileDurationChkMode}
                                                    options={hlsMediaFileDurationChkModeOptions}
                                                    selection
                                                    onChange={(event, data) => this.setState({hlsMediaFileDurationChkMode: data.value})}
                                                />
                                            </Form.Group>
                                            {!oauth.VODOnlyLicensePresent ?
                                                <OAuth.Feature DAI>
                                                    <Form.Group grouped>
                                                        <Checkbox
                                                            className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                            checked={this.state.hlsDaiEnable}
                                                            onChange={(e: any, data: any) => this.setState({hlsDaiEnable: data.checked})}
                                                        />
                                                        <Label className="left-align-label-500">
                                                            Enable Dynamic Ad Insertion
                                                        </Label>
                                                    </Form.Group>
                                                </OAuth.Feature>
                                                : null}
                                        </Form>
                                    </Segment>
                                </Segment.Group>
                                <Segment.Group className="system-config-segment">
                                    <Segment className="segment-header">Variant Name Options</Segment>
                                    <Segment>
                                        <Form>
                                            <Form.Group grouped>
                                                <Checkbox
                                                    className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                    checked={this.state.hlsVarNameOptPatternMatch}
                                                    onChange={(e: any, data: any) => this.setState({hlsVarNameOptPatternMatch: data.checked})}
                                                />
                                                <Label className="left-align-label-500">
                                                    Pattern Match
                                                </Label>
                                            </Form.Group>
                                        </Form>
                                    </Segment>
                                    <Segment>
                                        <Form>
                                            {hlsVariantNameOptions.map((nameOption, index) => {
                                                return <Form.Group grouped key={nameOption.stateName}>
                                                    <Checkbox
                                                        className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                        checked={this.state[nameOption.stateName]}
                                                        onChange={(e: any, data: any) => this.setState({
                                                            ...this.state,
                                                            [nameOption.stateName]: data.checked
                                                        })}
                                                    />
                                                    <Label className="left-align-label-500">
                                                        {nameOption.label}
                                                    </Label>
                                                </Form.Group>;
                                            })}
                                        </Form>
                                    </Segment>
                                    <Segment className="segment-header">Auto-Start Variant Streams</Segment>
                                    <Segment>
                                        <Form>
                                            <Form.Group grouped>
                                                <Label className="right-align-label-width"/>
                                                <Radio
                                                    label="Disable"
                                                    name="radioGroup"
                                                    value="disabled"
                                                    checked={this.state.hlsAutoStartComp === 'disabled'}
                                                    onChange={(e: any, data: any) => this.setState({hlsAutoStartComp: data.value})}
                                                />
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label-width"/>
                                                <Radio
                                                    label="All"
                                                    name="radioGroup"
                                                    value="all"
                                                    checked={this.state.hlsAutoStartComp === 'all'}
                                                    onChange={(e: any, data: any) => this.setState({hlsAutoStartComp: data.value})}
                                                />
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Checkbox
                                                    disabled={this.state.hlsAutoStartComp !== 'all'}
                                                    className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                    checked={this.state.hlsAutoStartCompAllMedia}
                                                    onChange={(e: any, data: any) => this.setState({hlsAutoStartCompAllMedia: data.checked})}
                                                />
                                                <Label
                                                    className={(this.state.hlsAutoStartComp !== 'all')
                                                        ? 'left-align-label-min240-disabled'
                                                        : 'left-align-label-min240'
                                                    }
                                                >
                                                    Media (Primary Video & Audio)
                                                </Label>
                                            </Form.Group>
                                            <OAuth.Feature QoE>
                                                <Form.Group grouped>
                                                    <Label className="left-align-label-85"/>
                                                    <Checkbox
                                                        disabled={this.state.hlsAutoStartComp !== 'all'}
                                                        className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                        checked={this.state.hlsQoeAllVideo}
                                                        // onChange={(e: any, data: any) => this.setState({hlsQoeAllVideo: data.checked})}
                                                        onChange={(event: any) => this.toggleVideo(1)}
                                                    />
                                                    <Label
                                                        className={(this.state.hlsAutoStartComp !== 'all') || (!this.state.hlsAutoStartCompAllMedia)
                                                            ? 'left-align-label-min340-disabled'
                                                            : 'left-align-label-min340'
                                                        }
                                                    >
                                                        Content Analysis
                                                    </Label>
                                                </Form.Group>
                                                <Form.Group grouped>
                                                    <Label className="left-align-label-85"/>
                                                    <Checkbox
                                                        disabled={(this.state.hlsAutoStartComp !== 'all') || (!oauth.QoELicensePresent) || (!this.state.hlsQoeAllVideo ? true : false)}
                                                        className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                        checked={this.state.hlsQoeAllPixel}
                                                        onChange={(e: any, data: any) => this.setState({hlsQoeAllPixel: data.checked})}
                                                    />
                                                    <Label
                                                        className={(this.state.hlsAutoStartComp !== 'all') || (!oauth.QoELicensePresent) || (!this.state.hlsQoeAllVideo ? true : false)
                                                            ? 'left-align-label-min340-disabled'
                                                            : 'left-align-label-min340'
                                                        }
                                                    >
                                                        Pixel Analysis
                                                    </Label>
                                                </Form.Group>
                                            </OAuth.Feature>
                                            <Form.Group grouped>
                                                <Checkbox
                                                    disabled={this.state.hlsAutoStartComp !== 'all'}
                                                    className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                    checked={this.state.hlsAutoStartCompAllAltRendAudio}
                                                    onChange={(e: any, data: any) => this.setState({hlsAutoStartCompAllAltRendAudio: data.checked})}
                                                />
                                                <Label
                                                    className={(this.state.hlsAutoStartComp !== 'all')
                                                        ? 'left-align-label-min240-disabled'
                                                        : 'left-align-label-min240'
                                                    }
                                                >
                                                    Audio Alternative Renditions
                                                </Label>
                                            </Form.Group>
                                            <OAuth.Feature QoE>
                                                <Form.Group grouped>
                                                    <Label className="left-align-label-85"/>
                                                    <Checkbox
                                                        disabled={(this.state.hlsAutoStartComp !== 'all') || (!this.state.hlsAutoStartCompAllAltRendAudio)}
                                                        className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                        checked={this.state.hlsQoeAllAudio}
                                                        onChange={(e: any, data: any) => this.setState({hlsQoeAllAudio: data.checked})}
                                                    />
                                                    <Label
                                                        className={(this.state.hlsAutoStartComp !== 'all') || (!this.state.hlsAutoStartCompAllAltRendAudio)
                                                            ? 'left-align-label-min340-disabled'
                                                            : 'left-align-label-min340'
                                                        }
                                                    >
                                                        Audio Analysis
                                                    </Label>
                                                </Form.Group>
                                            </OAuth.Feature>
                                            <Form.Group grouped>
                                                <Checkbox
                                                    disabled={this.state.hlsAutoStartComp !== 'all'}
                                                    className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                    checked={this.state.hlsAutoStartCompAllAltRendSubtitle}
                                                    onChange={(e: any, data: any) => this.setState({hlsAutoStartCompAllAltRendSubtitle: data.checked})}
                                                />
                                                <Label
                                                    className={(this.state.hlsAutoStartComp !== 'all')
                                                        ? 'left-align-label-min240-disabled'
                                                        : 'left-align-label-min240'
                                                    }
                                                >
                                                    Subtitle Alternative Renditions
                                                </Label>
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Checkbox
                                                    disabled={this.state.hlsAutoStartComp !== 'all'}
                                                    className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                    checked={this.state.hlsAutoStartCompAllIFrame}
                                                    onChange={(e: any, data: any) => this.setState({hlsAutoStartCompAllIFrame: data.checked})}
                                                />
                                                <Label
                                                    className={(this.state.hlsAutoStartComp !== 'all')
                                                        ? 'left-align-label-min240-disabled'
                                                        : 'left-align-label-min240'
                                                    }
                                                >
                                                    I-Frame
                                                </Label>
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label-width"/>
                                                <Radio
                                                    label="Limited"
                                                    name="radioGroup"
                                                    value="limited"
                                                    checked={this.state.hlsAutoStartComp === 'limited'}
                                                    onChange={(e: any, data: any) => this.setState({hlsAutoStartComp: data.value})}
                                                />
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Checkbox
                                                    disabled={this.state.hlsAutoStartComp !== 'limited'}
                                                    className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                    checked={this.state.hlsAutoStartCompLimitMedia}
                                                    onChange={(e: any, data: any) => this.setState({hlsAutoStartCompLimitMedia: data.checked})}
                                                />
                                                <Label
                                                    className={(this.state.hlsAutoStartComp !== 'limited')
                                                        ? 'left-align-label-min240-disabled'
                                                        : 'left-align-label-min240'
                                                    }
                                                >
                                                    Media (Primary Video & Audio)
                                                </Label>
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label
                                                    className={(this.state.hlsAutoStartComp !== 'limited') || (!this.state.hlsAutoStartCompLimitMedia)
                                                        ? 'right-align-label-width200-disabled'
                                                        : 'right-align-label-width200'
                                                    }
                                                >
                                                    Variants
                                                </Label>
                                                <div className="left-align-label-min150">
                                                    <Input
                                                        disabled={((this.state.hlsAutoStartComp !== 'limited') || (!this.state.hlsAutoStartCompLimitMedia))}
                                                        maxLength={63}
                                                        className="small-input-leftMargin"
                                                        value={this.state.hlsAutoStartCompLimitMediaVar}
                                                        onChange={(e: any, data: any) => this.setState({hlsAutoStartCompLimitMediaVar: data.value})}
                                                    /></div>
                                            </Form.Group>
                                            <OAuth.Feature QoE>

                                                <Form.Group grouped>
                                                    <Label className="left-align-label-85"/>
                                                    <Checkbox
                                                        disabled={(this.state.hlsAutoStartComp !== 'limited') || (!this.state.hlsAutoStartCompLimitMedia)}
                                                        className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                        checked={this.state.hlsQoeLimitVideo}
                                                        // onChange={(e: any, data: any) => this.setState({hlsQoeLimitVideo: data.checked})}
                                                        onChange={(event: any) => this.toggleVideo(2)}
                                                    />
                                                    <Label
                                                        className={(this.state.hlsAutoStartComp !== 'limited')  || (!this.state.hlsAutoStartCompLimitMedia)
                                                            ? 'left-align-label-min340-disabled'
                                                            : 'left-align-label-min340'
                                                        }
                                                    >
                                                        Content Analysis
                                                    </Label>
                                                </Form.Group>
                                                <Form.Group grouped>
                                                    <Label className="left-align-label-85"/>
                                                    <Checkbox
                                                        disabled={(this.state.hlsAutoStartComp !== 'limited') || (!oauth.QoELicensePresent) || (!this.state.hlsQoeLimitVideo ? true : false)}
                                                        className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                        checked={this.state.hlsQoeLimitPixel}
                                                        onChange={(e: any, data: any) => this.setState({hlsQoeLimitPixel: data.checked})}
                                                    />
                                                    <Label
                                                        className={(this.state.hlsAutoStartComp !== 'limited') || (!oauth.QoELicensePresent) || (!this.state.hlsQoeLimitVideo ? true : false)
                                                            ? 'left-align-label-min340-disabled'
                                                            : 'left-align-label-min340'
                                                        }
                                                    >
                                                        Pixel Analysis
                                                    </Label>
                                                </Form.Group>
                                            </OAuth.Feature>
                                            <Form.Group grouped>
                                                <Checkbox
                                                    disabled={this.state.hlsAutoStartComp !== 'limited'}
                                                    className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                    checked={this.state.hlsAutoStartCompLimitAltRendAudio}
                                                    onChange={(e: any, data: any) => this.setState({hlsAutoStartCompLimitAltRendAudio: data.checked})}
                                                />
                                                <Label
                                                    className={(this.state.hlsAutoStartComp !== 'limited')
                                                        ? 'left-align-label-min240-disabled'
                                                        : 'left-align-label-min240'
                                                    }
                                                >
                                                    Audio Alternative Rendition
                                                </Label>
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label
                                                    className={(this.state.hlsAutoStartComp !== 'limited')  || (!this.state.hlsAutoStartCompLimitAltRendAudio)
                                                        ? 'right-align-label-width200-disabled'
                                                        : 'right-align-label-width200'
                                                    }
                                                >
                                                    Variants
                                                </Label>
                                                <div className="left-align-label-min150">
                                                    <Input
                                                        disabled={((this.state.hlsAutoStartComp !== 'limited') || (!this.state.hlsAutoStartCompLimitAltRendAudio))}
                                                        maxLength={63}
                                                        className="small-input-leftMargin"
                                                        value={this.state.hlsAutoStartCompLimitAltRendAudioVar}
                                                        onChange={(e: any, data: any) => this.setState({hlsAutoStartCompLimitAltRendAudioVar: data.value})}
                                                    /></div>
                                            </Form.Group>
                                            <OAuth.Feature QoE>
                                                <Form.Group grouped>
                                                    <Label className="left-align-label-85"/>
                                                    <Checkbox
                                                        disabled={(this.state.hlsAutoStartComp !== 'limited')  || (!this.state.hlsAutoStartCompLimitAltRendAudio)}
                                                        className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                        checked={this.state.hlsQoeLimitAudio}
                                                        onChange={(e: any, data: any) => this.setState({hlsQoeLimitAudio: data.checked})}
                                                    />
                                                    <Label
                                                        className={(this.state.hlsAutoStartComp !== 'limited')  || (!this.state.hlsAutoStartCompLimitAltRendAudio)
                                                            ? 'left-align-label-min340-disabled'
                                                            : 'left-align-label-min340'
                                                        }
                                                    >
                                                        Audio Analysis
                                                    </Label>
                                                </Form.Group>
                                            </OAuth.Feature>
                                            <Form.Group grouped>
                                                <Checkbox
                                                    disabled={this.state.hlsAutoStartComp !== 'limited'}
                                                    className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                    checked={this.state.hlsAutoStartCompLimitAltRendSubtitle}
                                                    onChange={(e: any, data: any) => this.setState({hlsAutoStartCompLimitAltRendSubtitle: data.checked})}
                                                />
                                                <Label
                                                    className={(this.state.hlsAutoStartComp !== 'limited')
                                                        ? 'left-align-label-min240-disabled'
                                                        : 'left-align-label-min240'
                                                    }
                                                >
                                                    Subtitle Alternative Rendition
                                                </Label>
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label
                                                    className={(this.state.hlsAutoStartComp !== 'limited') || (!this.state.hlsAutoStartCompLimitAltRendSubtitle)
                                                        ? 'right-align-label-width200-disabled'
                                                        : 'right-align-label-width200'
                                                    }
                                                >
                                                    Variants
                                                </Label>
                                                <Input
                                                    disabled={((this.state.hlsAutoStartComp !== 'limited') || (!this.state.hlsAutoStartCompLimitAltRendSubtitle))}
                                                    maxLength={63}
                                                    className="small-input-leftMargin"
                                                    value={this.state.hlsAutoStartCompLimitAltRendSubtitleVar}
                                                    onChange={(e: any, data: any) => this.setState({hlsAutoStartCompLimitAltRendSubtitleVar: data.value})}
                                                />
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Checkbox
                                                    disabled={this.state.hlsAutoStartComp !== 'limited'}
                                                    className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                    checked={this.state.hlsAutoStartCompLimitIFrame}
                                                    onChange={(e: any, data: any) => this.setState({hlsAutoStartCompLimitIFrame: data.checked})}
                                                />
                                                <Label
                                                    className={(this.state.hlsAutoStartComp !== 'limited')
                                                        ? 'left-align-label-min240-disabled'
                                                        : 'left-align-label-min240'
                                                    }
                                                >
                                                    I-Frame
                                                </Label>
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label
                                                    className={(this.state.hlsAutoStartComp !== 'limited')  || (!this.state.hlsAutoStartCompLimitIFrame)
                                                        ? 'right-align-label-width200-disabled'
                                                        : 'right-align-label-width200'
                                                    }
                                                >
                                                    Variants
                                                </Label>
                                                <Input
                                                    disabled={((this.state.hlsAutoStartComp !== 'limited') || (!this.state.hlsAutoStartCompLimitIFrame))}
                                                    maxLength={63}
                                                    className="small-input-leftMargin"
                                                    value={this.state.hlsAutoStartCompLimitIFrameVar}
                                                    onChange={(e: any, data: any) => this.setState({hlsAutoStartCompLimitIFrameVar: data.value})}
                                                />
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label-width"/>
                                                <Checkbox
                                                    label="No Duplicates"
                                                    className="config-checkbox"
                                                    checked={this.state.hlsAutoStartCompNoDup}
                                                    onChange={(e: any, data: any) => this.setState({hlsAutoStartCompNoDup: data.checked})}
                                                />
                                            </Form.Group>
                                        </Form>
                                    </Segment>
                                </Segment.Group>
                            </div>
                        </React.Fragment>
                    );
                }}
            </OAuth.Context>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/config/monitoring/appleStreamingConfig.tsx